import React from "react";
import styles from "./ArtistSection.module.scss";
import ReactReadMoreReadLess from "react-read-more-read-less";
import artistImage from "../../../assets/images/artist-image.jpg";

const artist = {
  id: 1,
  image: artistImage,
  fullName: "John Doe",
  description:
    "Name Lastname belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going throut. Name Lastname belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.",
};

const ArtistSection = () => {
  return (
    <div className={`artistsRef ${styles.artistSectionContainer}`}>
      <div className="container">
        <div className={styles.title}>Our Artists</div>
        <div className={styles.artistList}>
          {Array.from(Array(3), (_, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.cardImage}>
                <img src={artist.image} alt={artist.fullName} />
              </div>
              <div className={styles.info}>
                <h2>{artist.fullName}</h2>
                <p className={styles.desc}>
                  <ReactReadMoreReadLess
                    charLimit={400}
                    readMoreText={"Read more ▼"}
                    readLessText={"Read less ▲"}
                  >
                    {artist.description}
                  </ReactReadMoreReadLess>
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.loadMore}>
          <button>Load More</button>
        </div>
      </div>
    </div>
  );
};

export default ArtistSection;
